export default __webpack_public_path__ + "static/media/youtubehumano.d96564d9.svg";